export const API_KEY = "6b3b86c639c802af1c507983ac493884";
export const base_url = "https://api.themoviedb.org/3/";
export const base_img_url = "https://image.tmdb.org/t/p/original/";
